<ng-container>
    <h3 class="form-header" mat-dialog-title *ngIf="!initialData" i18n="@@a361ef736683be2906b609aaa77d7bd793ed53f6" t="a361ef736683be2906b609aaa77d7bd793ed53f6">Add Bank</h3>
    <h3 class="form-header" mat-dialog-title *ngIf="initialData" i18n="@@58181035684a6d14eb1425dc344ab578605fbf94" t="58181035684a6d14eb1425dc344ab578605fbf94">Edit Bank</h3>
    <bank-edit
        #bankEditComponent
        [tsl-supplierBank]="supplierBank"
        [tsl-initialData]="supplierBank"
        [tsl-readOnly]="false"
        [tsl-legalName]="legalName"
        [tsl-showPaymentOriginControl]="true"
        [tsl-generalSettings]="generalSettings$ | async"
        [tsl-countries]="countries$ | async"
        [tsl-paymentOrigins]="paymentOrigins$ | async"
        [tsl-intermediaryPaymentOrigins]="intermediaryPaymentOrigins$ | async"
        [tsl-currencies]="currencies$ | async"
        [tsl-bankConfiguration]="bankConfig$ | async"
        [tsl-hideCancelButton]="false"
        [tsl-hideSaveButton]="false"
        [tsl-supplierBankDocType]="supplierBankDocType"
        [tsl-hideDocumentSection]="false"
        [tsl-supplierCode]="supplierCode"
        (tsl-onCountryChange)="countryChangeEventHandler($event)"
        (tsl-onPaymentOriginChange)="onPaymentOriginChangedEvent($event)"
        (tsl-onSubmit)="submitEventHandler($event.supplierBank, $event.uploadFiles)"
        (tsl-onSave)="saveEventHandler($event.supplierBank)"
        (tsl-onCancel)="closeDialog()"
    >
    </bank-edit>
</ng-container>
